import classes from "./FolderListItem.module.css";
import Folder from "../../../../../../api/folder/Folder";
import {IconDotsVertical, IconFolderFilled} from "@tabler/icons-react";
import {useContext} from "react";
import FolderContext from "../../../../../../contexts/folder/FolderContext";
import QRCodeContext from "../../../../../../contexts/qr-code/QRCodeContext";
import {ActionIcon, Menu} from "@mantine/core";
import Notifications from "../../../../../../utils/notifications/Notifications";

/**
 * Properties for FolderListItem
 * @author Kacper Faber
 * @since 0.1.8
 */
type FolderListItemProps = {
    folder: Folder;
}

/**
 *
 * @author Kacper Faber
 * @since 0.1.8
 * @constructor
 */
function FolderListItem(props: FolderListItemProps) {
    /**
     * Folder context
     * @author Kacper Faber
     * @since 0.1.8
     */
    const folderContext = useContext(FolderContext);

    const qrCodeContext = useContext(QRCodeContext);

    /**
     * Deletes folder using folderContext.deleteFolder().
     * Shows notifications in catch.
     * @author Kacper Faber
     * @since 0.1.8
     */
    const doDeleteFolder = () => {
        folderContext.deleteFolder(props.folder.id)
            .then(Notifications.onDeleteSuccess)
            .catch(Notifications.onDeleteFailed);
    }

    /**
     *
     * @author Kacper Faber
     * @since 0.1.8
     */
    const isActive = () => {
        return qrCodeContext.query.folder == props.folder.id;
    };

    const getClasses = () => {
        return `${classes.root} ${isActive() ? classes.active : ''}`;
    };

    const onItemClicked = () => {
        if (isActive()) {
            qrCodeContext.setQuery({...qrCodeContext.query, folder: undefined});
            return;
        }
        qrCodeContext.setQuery({...qrCodeContext.query, folder: props.folder.id});
    }

    return (
        <div className={getClasses()}>
            <div className={classes.container} onClick={onItemClicked}>
                <IconFolderFilled
                    className={classes.icon}
                />

                <div className={classes.title}>
                    {props.folder.name}
                </div>
            </div>

            <Menu>
                <Menu.Target>
                    <ActionIcon variant="transparent" c="#d4d4d4">
                        <IconDotsVertical
                            size={15}
                            className={classes.menu}
                        />
                    </ActionIcon>
                </Menu.Target>

                <Menu.Dropdown>
                    <Menu.Item
                        c="red"
                        children="Usuń"
                        onClick={doDeleteFolder}
                    />
                </Menu.Dropdown>
            </Menu>
        </div>
    );
}

export default FolderListItem;

// TODO: FolderListItem.tsx
// Use colours from theme